var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 35,
    viewBox: "0 0 66 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.286H4.9405V34.041H62.5625V20.0675H65.18V14.0265H40.057V6.286H44.3755V0H0.1845V0.0895004H0V6.286ZM48.7505 32.5865H61.1085V20.0675H56.8355V26.7325H55.381V20.0675H40.057V32.5865H47.296V24.8265H48.7505V32.5865ZM30.5075 20.0675V32.5865H38.603V20.0675H30.5075ZM23.0685 20.0675V32.5865H29.0535V20.0675H23.0685ZM21.6145 20.7435V20.0675H15.6255V32.5865H21.61V20.7435H21.6145ZM6.3945 20.0675V32.5865H14.171V20.0675H6.3945ZM6.3945 15.481V18.6135H14.171V15.481H6.3945ZM15.6255 15.481V18.6135H21.6145V15.481H15.6255ZM23.0685 15.481V18.6135H29.0535V15.481H23.0685ZM30.5075 15.481V18.6135H38.603V15.481H30.5075ZM40.057 15.481V18.6135H63.7255V15.481H40.057ZM6.3945 14.0265H38.603V6.286H6.3945V14.0265ZM1.4545 4.832H42.9215V1.4545H1.4545V4.832Z",
    fill: "#255056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.3ccddf5394aa0f31d50c12e01e7f02a0.svg";
export { ForwardRef as ReactComponent };